export const MIN_CELL_WIDTH_PX = 155;
export const CHECKBOX_WIDTH = 40;
